import { Fragment } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ListDivider, Typography } from '@optimus-web/core';
import { CardDetailListItemElement } from '../../styles';
import SidebarExceptionsInfo from './SidebarExceptionsInfo';

const ExceptionsSection = ({ exceptions, timeUnit, isServiceDayUse }: $TSFixMe) => (
    <Fragment>
        <ListDivider />
        <CardDetailListItemElement>
            <Typography textStyle="bodyMediumStrong" as="div">
                <LocalizedText textKey={TextKey.RestrictionExceptions} />
            </Typography>
        </CardDetailListItemElement>
        <SidebarExceptionsInfo exceptions={exceptions} timeUnit={timeUnit} isServiceDayUse={isServiceDayUse} />
    </Fragment>
);

export default ExceptionsSection;
